import React from "react";
import Card from "../../components/page/Card";
import useApi from "../../hooks/useApi.js";
import UsuarioApiClient from "../../api/usuario.js";
import PerfilCardContent from "./Perfil/PerfilCardContent.jsx";
import CommonSwal from "../../components/Swal/commonSwal.jsx";
import { AppContext } from "../../contexts/AppContext.jsx";
import Format from "../../helpers/Format.js";
import OptionsSwal from "../../components/Swal/optionsSwal.jsx";
import ErrorSwal from "../../components/Swal/errorSwal.jsx";
import Validation from "../../helpers/Validation.js";

function Perfil() {
  const [values, setValues] = React.useState({});
  const { session, getSession } = React.useContext(AppContext);

  const { request: getPerfil, data: perfilResponse } = useApi(
    UsuarioApiClient.getPerfil
  );
  const atualizaPerfilApi = useApi(UsuarioApiClient.atualizaPerfil);

  //Busca dados do perfil ao renderizar tela
  React.useEffect(() => {
    const buscarPerfil = async () => {
      await getPerfil();
    };
    buscarPerfil();
  }, [getPerfil]);

  //Define o retorno do backend nos valores dos campos
  React.useEffect(() => {
    if (!perfilResponse) return;
    setValues((prevValues) => ({
      ...prevValues,
      uid: perfilResponse.uid,
      nome: perfilResponse.nome,
      email: perfilResponse.email,
    }));
  }, [perfilResponse, setValues]);

  //Define dados do usuário da sessão
  React.useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      imagemPerfil: session.image_profile,
      usuarioNivel: session.codigo,
    }));
  }, [session.codigo, session.image_profile, setValues]);

  const salvarPerfil = async () => {
    if (Validation.validarEmails(values.email))
      return ErrorSwal({
        text: "E-mail inválido.",
      });

    if (await verificaEmailAlterado(values.email)) return;

    const formData = new FormData();
    formData.append("uid", values.uid);
    formData.append("nome", values.nome);
    formData.append("email", values.email);
    formData.append("usuarioNivel", values.usuarioNivel);
    if (Validation.verificarForm(formData))
      return CommonSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    if (values.imagemPerfil !== session.image_profile)
      formData.append(
        "imagemPerfil",
        values.imagemPerfil
          ? await Format.formataBase64(values.imagemPerfil)
          : null
      );

    const atualizaPerfilResponse = await atualizaPerfilApi.request(formData);
    if (!atualizaPerfilResponse) return;
    await getSession();
    CommonSwal({ ...atualizaPerfilResponse });
  };

  const verificaEmailAlterado = (email) => {
    return new Promise((resolve) => {
      if (email === session.email) return resolve(false);
      OptionsSwal({
        title: "Você realmente deseja alterar o e-mail de acesso à sua conta?",
        text: "Esta ação modificará seu login e o endereço para recuperação de senha. Prosseguir com a alteração?",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(false);
        } else {
          setValues({
            ...values,
            email: session.email,
          });
          resolve(true);
        }
      });
    });
  };

  return (
    <>
      <Card>
        <PerfilCardContent
          valuesHook={{ values, setValues }}
          salvarPerfil={salvarPerfil}
        />
      </Card>
    </>
  );
}

export default Perfil;
